import { alias, object, primitive, serializable } from 'serializr';

export class CommodityDetails {
  @serializable
  id?: number;

  @serializable(alias('name'))
  commodityName?: string;

  @serializable(alias('revenue_percentage'))
  revenuePercentage?: number;

  @serializable(alias('scope_1_emission'))
  scope1Emission?: string;

  @serializable(alias('scope_2_emission'))
  scope2Emission?: string;

  @serializable(alias('scope_1_and_2_emission'))
  scope1And2Emission?: string;
}

export class CommodityAddress {
  @serializable
  city?: string;

  @serializable
  street?: string;

  @serializable
  province?: string;

  @serializable(alias('postal_code'))
  postalCode?: string | null;

  @serializable
  country?: string;

  @serializable(alias('country_code'))
  countryCode?: string;

  @serializable(alias('province_code'))
  provinceCode?: string;

  @serializable
  latitude?: string;

  @serializable
  longitude?: string;

  constructor() {
    if (this?.getFormattedAddress) {
      this.getFormattedAddress = this.getFormattedAddress.bind(this);
    }
  }

  getFormattedAddress?(): string {
    let addressParts = [];

    if (this?.city) {
      addressParts.push(this.city);
    }
    if (this?.country) {
      addressParts.push(this.country);
    }
    if (this?.postalCode) {
      addressParts.push(this.postalCode);
    }

    // If all fields are undefined or empty, return an empty string
    if (addressParts.length === 0) {
      return '';
    }

    return addressParts.join(', ');
  }
}

export class LocationDetails {
  @serializable
  id?: number;

  @serializable(alias('name'))
  farmName?: string;

  @serializable(object(CommodityAddress))
  address?: CommodityAddress;
}

export class FuelAndEnergyDetails {
  @serializable(object(CommodityDetails))
  commodity?: CommodityDetails;

  @serializable(object(LocationDetails))
  location?: LocationDetails;
}
